import { render, staticRenderFns } from "./SupplierAccountDisplayView.vue?vue&type=template&id=3fb6d9f8"
import script from "./SupplierAccountDisplayView.vue?vue&type=script&lang=js"
export * from "./SupplierAccountDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports